<div *ngIf="(store$ | async) as store" class="container d-flex flex-column h-100">
  <h3 class="text-center">Third Party Provider Contract Preview</h3>
  <mat-divider class="mb-3"></mat-divider>
  <div class="d-flex flex-column flex-grow-1 overflow-auto">
    <ng-third-party-contract-info *ngIf="contract" [contract]="contract"></ng-third-party-contract-info>
    <h5 class="p-4 mt-4 text-center text-muted" *ngIf="!contract">No Contract Provided</h5>
  </div>
  <div class="d-flex justify-content-end mt-3">
    <button mat-stroked-button matStepperPrevious color="accent" aria-label="Previous Button" class="mr-3"
            [disabled]="store.core.loadingCreation || store.core.loadingUpdateLOA">
      Back
    </button>
    <div>
      <button mat-flat-button color="accent" aria-label="Sign/update Button" (click)="sign()"
              [disabled]="store.core.loadingCreation || store.core.loadingUpdateLOA">
        {{ isEdit ? 'Update' : 'Sign' }}
      </button>
      <mat-progress-bar mode="indeterminate" color="accent" *ngIf="store.core.loadingCreation || store.core.loadingUpdateLOA"></mat-progress-bar>
    </div>
  </div>
</div>
